module.exports = __webpack_public_path__ + "img/book.bf6bfa37.svg";